import { fadeInOnScroll } from './fade-in-on-scroll';
import { toggleRegions, locationModals } from '../modules/locations-list';
import gsap from "gsap";
import { ScrollToPlugin } from "gsap/ScrollToPlugin";

export const locationSearchSubmit = async () => {
		
	const inputField = document.getElementById('address-input');

    if(inputField) {

		inputFieldValue = inputField.value.trim();
        
        // Get the value from URL parameters
        let urlParams = new URLSearchParams(window.location.search);
        let urlAddressValue = urlParams.get('address');

        const addressValue = inputFieldValue || urlAddressValue;

        if (addressValue) {

            document.querySelector('.js-location-container').innerHTML = '';
            let elementToScrollTo = document.querySelector('.locations__list-loader');

            document.querySelector('.locations__list-loader').style.display = 'flex';
        
            gsap.registerPlugin(ScrollToPlugin);
            gsap.to(window, {
                duration: 1, 
                scrollTo: {
                    y: elementToScrollTo, // Scroll to the element
                    offsetY: 200 // Adjust for the height of scroll-to-links
                }
            });

            const postcode = addressValue;
            const coords = await getPostcodeLatLng(postcode);

            if (coords) {
                runLocationsSearch(coords);
            } else {
                alert('There has been an error');
            }
        }
    }
}

const searchButton = document.getElementById('location-search');
if (searchButton) {
    searchButton.addEventListener('click', locationSearchSubmit);
}

async function getPostcodeLatLng(postcode) {
	
	if (!postcode) return false;

  	try {
  		const response = await fetch(`https://api.postcodes.io/postcodes/${postcode}`);
  		
  		if (response.ok) {
    		const data = await response.json();

    		if (data.status === 200 && data.result.latitude && data.result.longitude) {
      		
	      		return {
	        		lat: data.result.latitude,
	       		 	lng: data.result.longitude,
	      		};
	    	
	    	} else {
	      		return false;
	    	}
  		} else {
    		console.error("Error fetching data:", response.statusText);
    		return false;
  		}
	} catch (error) {
  		console.error("Error fetching data:", error);
  		return false;
	}
}

const runLocationsSearch = async (coords) => {
    
    const container = document.querySelector('.js-location-container');
    const regionContainer = document.querySelector('.locations__list-region-container');
    const regionSearchBar = document.querySelector('.locations__search-bar--regions');
    const postcodeSearchBar = document.querySelector('.locations__search-bar--postcode');
    const resultCount = document.querySelector('.js-location-result-count');

    regionContainer.style.display = 'none';
    regionSearchBar.style.display = 'none';
    container.style.display = 'block';
    postcodeSearchBar.style.display = 'flex';

  	const getFetchData = () => {
        const formData = new FormData();
        formData.append('lat', coords.lat);
        formData.append('lng', coords.lng);
        formData.append('action', 'ajax_location_search');
            
        const ajaxData = new URLSearchParams(formData);

        return ajaxData;
    }

    const data = getFetchData();

    fetch(igniteAjax.ajaxurl, {
        method: 'POST',
        credentials: 'same-origin',
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
            'Cache-Control': 'no-cache',
        },
        body: data
    })
    .then((response) => response.json())
    .then((data) => {
        container.innerHTML = data.html;
		resultCount.innerHTML = data.count + ' results within 30 miles';
        document.querySelector('.locations__list-loader').style.display = 'none';
    	fadeInOnScroll();
        toggleRegions();
    	locationModals();
    })
    .catch((error) => {
        console.error(error);
    });  
};